export default [
  {
    label: 2014,
    value: 2014
  },
  {
    label: 2013,
    value: 2013
  },
  {
    label: 2012,
    value: 2012
  },
  {
    label: 2011,
    value: 2011
  },
  {
    label: 2010,
    value: 2010
  },
  {
    label: 2009,
    value: 2009
  },
  {
    label: 2008,
    value: 2008
  },
  {
    label: 2007,
    value: 2007
  },
  {
    label: 2006,
    value: 2006
  }
]



// WEBPACK FOOTER //
// ./src/options/years.js